import Vue from 'vue';
import Vuex from 'vuex';
import { dissoc, isEmpty, find, pipe, map, sum } from 'ramda';
import PollService from '@/services/PollService';
import { checkLang } from '../services/TranslateService';

const appUrl = new URL(window.location.href);
const definedLang = checkLang(appUrl.searchParams.get('lang'));

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    poll: {},
    stats: {},
    inputLanguage: definedLang
  },

  mutations: {
    SET_ACTIVE_POLL: (state, poll) => {
      state.poll = poll;
    },
    SET_STATS: (state, stats) => {
      state.stats = stats;
    }
  },

  getters: {
    poll: state => (isEmpty(state.poll) ? null : dissoc('questions', state.poll)),
    question: state => find(q => q.isActive || q.isDisplayed)(state.poll.questions) || {},
    answers: (state, getters) => getters.question.answers || [],
    statsOfQuestion: state => questionId => {
      const answers = (state.stats.answers || []).filter(answer => {
        return answer.questionId === questionId;
      });
      const totalVoteCount = pipe(
        map(answer => answer.voteCount),
        sum
      )(answers);
      return {
        totalVoteCount,
        answers
      };
    },
    getInputLanguage: state => state.inputLanguage    
  },

  actions: {
    getActivePoll: ({ commit }) => {
      PollService.getActive().then(({ poll, stats }) => {
        commit('SET_ACTIVE_POLL', poll);
        commit('SET_STATS', stats);
      });
    }
  }
});
